import axios from 'axios';


export const useAPI = () => {


    const token = ''
    const defaultHeader = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
    };


    const customFetch = ({ endpoint, method = 'GET', body = {}, headers = defaultHeader, responseType }) => {
        const hostname = window.location.hostname;
        //const hostname = '212.174.62.230';

        const baseUrl = 'http://' + hostname + `:9000/api`;
        let url = `${baseUrl}/${endpoint}`;

        const options = {
            method,
            headers
        };

        if (Object.keys(body).length) options.data = JSON.stringify(body);
        if (responseType) options.responseType = responseType;

        return axios(url, options)
            .then((response) => {
               
                return response.data;
            })
            .catch((error) => {
                if (error?.response?.data) {
                    console.log('danger');
                } else {
                    if (!error?.response?.status) {
                        console.log('toggle');
                    } else {
                        console.log('danger');
                    }
                }
            });
    };

    const get = (endpoint, id, query, token) => {
        const url = `${endpoint}${id ? `/${id}${query ? `?${query}` : ''}` : `${query ? `?${query}` : ''}`}`;

        if (token) {
            defaultHeader.Authorization = `Bearer ${token}`;
        }
        return customFetch({ endpoint: url });
    };

    const post = (endpoint, body = {}) => {
        // if (!Object.keys(body).length) throw new Error('to make a post you must provide a  body');

        return customFetch({ endpoint, method: 'POST', body });
    };

    const put = (endpoint, id, body = {}, token) => {
        if (!id && !body) throw new Error('to make a put you must provide the id and the   body');
        if (token) {
            defaultHeader.Authorization = `Bearer ${token}`;
        }

        const url = `${endpoint}${id ? `/${id}` : ''}`;
        return customFetch({
            endpoint: url,
            method: 'PUT',
            body,
            headers: defaultHeader
        });
    };

    const del = (endpoint, id, query) => {
        if (!id) throw new Error('to make a delete you must provide the id and the body');
        const url = `${endpoint}${id ? `/${id}${query ? `?${query}` : ''}` : `${query ? `?${query}` : ''}`}`;

        return customFetch({ endpoint: url, method: 'DELETE' });
    };

    return {
        get,
        post,
        put,
        del
    };
};
